<template lang="pug">
  .component-backoffice-policy-list.row.column
    base-list(:component="component", :dataLoader="dataLoader", :showPerPageSelect="true",)
</template>

<script type="text/babel">
  import KeplerBackofficeSdk from 'src/lib/kepler/backoffice'
  import BaseList from './BaseList'


  export default {
    name: 'UserList',
    components: {
      BaseList,
    },
    data: function () {
      return {
        component: require('src/components/backoffice/User.vue'),
      }
    },
    created() {
      this.dataLoader()
    },
    methods: {
      dataLoader(callback, page, resultsPerPage) {
        KeplerBackofficeSdk.users.list(page, resultsPerPage).all((data) => {
          callback(data)
        })
      }
    },
  }
</script>

<style lang="sass" rel="stylesheet/sass">

</style>



// WEBPACK FOOTER //
// UserList.vue?70bc7c43